import moment from "moment";
import { createCrudActions } from '../utils/crudGenerator';

const formatInstallations = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
        registrationDate: item.registrationDate && moment(item.registrationDate),
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchInstallations,
    create: createInstallation,
    update: updateInstallation,
    delete: deleteInstallations
} = createCrudActions('INSTALLATION', "Instalación", formatInstallations);
